import React from "react";
import {createEngageApp} from "engage-client";
import {Role} from "engage-common/types";
import {TriviaState, DefaultAppState, DefaultUserState, UserState} from "./state/state";
import {TriviaMessage} from "./messages/messages";
import Host from "./components/Host";
import Player from "./components/Player";
import Shared from "./components/Shared";
import CreateLobby from "./components/host/CreateLobby";
import Marketing, {GameTime} from "./components/landing-pages/Marketing";
import {GoogleAnalytics} from "./components/util/GoogleAnalytics";

const {context, AppComponent} = createEngageApp<TriviaState,UserState,TriviaMessage>(
    {title: "SAS Engage Trivia", teams: true}, DefaultAppState(), DefaultUserState());

export const EngageAppContext = {current: context};

function App() {

    const triviaTimes:GameTime[] = [{
        timeText: "9:15AM | 4:00PM EST.",
        dateText: "Wednesday, Jan 27"
    }];
    const sgfTimes:GameTime[] = [{
        timeText:"12:15PM ET",
        dateText:"Tuesday, May 18"
    }, {
        timeText:"12:15PM CET",
        dateText:"Tuesday, May 25"
    }];
    const sasBowlTimes:GameTime[] = [{
        timeText: "10:00 AM ET",
        dateText: "Wednesday, April 16"
    }];
    const sasForumTimes:GameTime[] = [{
        timeText: "10.30 Uhr",
        dateText: "27. Oktober"
    }];
    const astronomyDaysTimes:GameTime[] = [{
       timeText: "6:00PM ET",
       dateText: "Saturday, Jan 29"
    }];
    const piDayTimes:GameTime[] = [{
       timeText: "10:00AM ET",
       dateText: "Tuesday, March 14"
    }];


    const overrideRoutes = {
        "/shared": <Shared sharedDisplay={true} showLogo={true}/>,
        /*
        "/trivia": <Marketing lobbyCode="SAS" welcomeText="Welcome!" title="Engage Trivia"
                              subtitle="Brought to you by SAS Social Innovation"
                              times={triviaTimes}/>,
        "/sgf": <Marketing lobbyCode="SGF" welcomeText="Welcome!" title="SAS Global Forum"
                           subtitle="Brought to you by SAS Social Innovation"
                            times={sgfTimes}/>,
       "/sasforum": <Marketing lobbyCode="SASFORUM" welcomeText="Das interaktive" title="SAS Forum Quiz"
                               subtitle=""
                               times={sasForumTimes} />,
        "/astrosat": <Marketing lobbyCode="ASTROSAT" welcomeText="Welcome!" title="Astronomy Days Trivia"
                               subtitle="Brought to you by SAS"
                               times={astronomyDaysTimes} />,
        */
        "/sasbowl": <Marketing lobbyCode="SASBOWL" welcomeText="Welcome!" title="SAS Bowl L, PROC HTTP"
                               subtitle="Brought to you by SAS Communities"
                               times={sasBowlTimes} />,
        "/piday23": <Marketing lobbyCode="piday23" welcomeText="Welcome!" title="Pi Day Trivia"
                               subtitle="Brought to you by SAS Corporate Communications"
                               times={piDayTimes} />


    };
    const roleComponents = {
        [Role.host] : Host,
        [Role.user] : Player
    };

    return (
        <AppComponent overrideRoutes={overrideRoutes} roleComponents={roleComponents} createLobbyExtension={CreateLobby} addtlComponents={<GoogleAnalytics/>}/>
    );
}

export default App;
